import { render, staticRenderFns } from "./modal-iframe.vue?vue&type=template&id=7fabc1ca&scoped=true&"
import script from "./modal-iframe.vue?vue&type=script&lang=js&"
export * from "./modal-iframe.vue?vue&type=script&lang=js&"
import style0 from "./modal-iframe.vue?vue&type=style&index=0&id=7fabc1ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fabc1ca",
  null
  
)

export default component.exports